<template>
  <div
    v-bind="$attrs"
    class="tooltip__container"
    @mouseover="showIcon ? (show = true) : ''"
    @mouseout="showIcon ? (show = false) : ''"
  >
    <i v-if="showIcon" class="tooltip__icon mdi" :class="getIcon()"></i>
    <div
      v-show="show"
      :class="[
        `tooltip__content--${theme}`,
        { 'bounce-animation': bounce },
        `${arrowPlacement}-arrow`
      ]"
      class="tooltip__content arrow"
      :style="{
        width: width + 'px',
        height: height + 'px',
        'margin-left': '-' + width / 2 + 'px'
      }"
      @click="handleClick()"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    showTooltip: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    icon: {
      required: false,
      default: null
    },
    width: {
      required: false,
      default: 'auto'
    },
    height: {
      required: false,
      default: 'auto'
    },
    clickCallback: {
      type: Function,
      required: false
    },
    theme: {
      type: String,
      default: 'dark'
    },
    bounce: {
      type: Boolean,
      default: false
    },
    hideOnClick: {
      type: Boolean,
      default: true
    },
    arrowPlacement: {
      type: String,
      default: 'bottom',
      validator: function (value) {
        // The value must match one of these strings
        return ['top', 'bottom', 'left', 'right'].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      DEFAULT_ICON: 'mdi-information-outline',
      show: false
    };
  },
  mounted() {
    this.show = this.showTooltip;
  },
  watch: {
    showTooltip(value) {
      this.show = value;
    }
  },
  methods: {
    getIcon() {
      return this.icon ? this.icon : this.DEFAULT_ICON;
    },
    handleClick() {
      if (this.hideOnClick) {
        this.show = false;
      }

      if (this.clickCallback) {
        this.clickCallback();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@sass/_variables.scss';
@import '@sass/_animations.scss';
.mdi {
  font-size: 1.2em;
}

.tooltip {
  &__container {
    display: inline-block;
    position: relative;
    cursor: pointer;
    z-index: 999999;
  }

  &__icon:hover {
    cursor: pointer;
  }

  &__content {
    background-color: $symptoms-black;
    position: absolute;
    display: inline-block;
    bottom: 2.5em;
    left: 50%;
    color: #fff;
    padding: 1em;
    border-radius: 6px;
    min-width: 100px;
  }

  &__content--dark {
    opacity: 0.8;
    background-color: $symptoms-black;
    color: #fff;
  }

  &__content--dark:after {
    border-top: 12px solid $symptoms-black;
  }

  &__content--light {
    background-color: white;
    color: #000;
  }

  &__content--light:after {
    border-top: 12px solid white;
  }
}

.arrow:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 12px;
}

.bottom-arrow:after {
  border-color: $symptoms-black transparent transparent transparent;
  top: 100%;
  left: 50%;
  margin-left: -12px;
}

.top-arrow:after {
  border-color: transparent transparent $symptoms-black transparent;
  bottom: 100%;
  left: 50%;
  margin-left: -12px;
}

.left-arrow:after {
  border-color: transparent $symptoms-black transparent transparent;
  top: 50%;
  right: 100%;
  margin-top: -12px;
}

.right-arrow:after {
  border-color: transparent transparent transparent $symptoms-black;
  top: 50%;
  left: 100%;
  margin-top: -12px;
}
</style>
